import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SCHOOL_LAB_POC_UPDATE } from "../apiRoutes";
import axiosAuth from "../../axiosAuth";

interface UpdateSchoolLabPocRequest {
  // payload: { pocList: [...] }
  pocList: {
    schoolId: string;
    pocId?: string; // optional for some items
    pocName: string;
    pocDesignation: string;
    pocPhone: string;
    pocEmail: string;
    isDeleted?: boolean;
  }[];
}

interface UpdateSchoolLabPocResponse {
  success: boolean;
  message: string;
  data: any;
}

export const useUpdateSchoolLabPocMutation = (options?: {
  onSuccess?: (data: UpdateSchoolLabPocResponse) => void;
  onError?: (error: any) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: UpdateSchoolLabPocRequest): Promise<UpdateSchoolLabPocResponse> => {
      // POST/PUT to update endpoint with body { pocList: [...] }
      const response = await axiosAuth.put(SCHOOL_LAB_POC_UPDATE, request);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch school POCs
      queryClient.invalidateQueries({ queryKey: ["schoolPocs"] });
      queryClient.invalidateQueries({ queryKey: ["schoolLabPoc"] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
